import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { TextInput, Button } from "flowbite-react";
import { useGetData } from "../../../../../hooks/useGetData";
import { useMutationData } from "../../../../../hooks/useMutationData";
import { EvaluadoInterface } from "../../../../../interfaces/EvaluadoInterface";
import { FechaToxicologicaInterface } from "../../../../../interfaces/FechaToxicologicaInterface";
import Header from "../../../../../components/HeaderForms/HeaderForms";
import { ThemeContext } from "../../../../../components/ThemeContext/ThemeContext";

export const AutorizacionTXEditarScreen = () => {
  const { isDarkMode } = useContext(ThemeContext);
  const tituloFormulario =
    "AUTORIZACIÓN AL PROCESO DE EVALUACIONES DE PRUEBA TOXICOLÓGICA";
  const [formData, setFormData] = useState({
    date: "",
  });

  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const { control, handleSubmit, setValue, reset } = useForm();

  const queryFechaTX = useGetData<FechaToxicologicaInterface[]>({
    url: `/fecha-toxi/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "fecha-toxi"],
  });

  const mutateFechaTX = useMutationData({
    url: `/fecha-toxi/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "fecha-toxi"],
  });

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (queryFechaTX.data && queryFechaTX.data.length > 0) {
      const fechatx = queryFechaTX.data[0];
      reset({
        fecha_autorizaciontx: fechatx.fecha_autorizaciontx || "",
      });
    }
  }, [queryFechaTX.data, reset]);

  const navigate = useNavigate();

  return (
    <div className={`min-h-screen ${isDarkMode ? "bg-gray-900" : "bg-gray-50"}`}>
      <div className="container mx-auto p-4">
        <div className={`max-w-4xl mx-auto shadow-lg rounded-lg overflow-hidden ${isDarkMode ? "bg-gray-800 text-white" : "bg-white text-gray-800"}`}>
          <form
            onSubmit={handleSubmit((data) => {
          console.log(data);

          const formData = {
            ...data,
          };

          // Mutación para guardar la Fecha de Detección de Riesgos
          mutateFechaTX.mutate(
            {
              data: { fecha_autorizaciontx: data.fecha_autorizaciontx },
              tipo: "put",
            },
            {
              onSuccess: () => {
                navigate(`/toxicologica/${evaluadosList_id}`);
              },
              onError: (error) => {
                console.error("Error al guardar Fecha Médica:", error);
              },
            }
          );
        })}
        className=""
      >
        {/* Header */}
        <Header titulo={tituloFormulario} />

        {/* Contenido del formulario */}
        <div className={`p-6 ${isDarkMode ? "bg-gray-800" : "bg-white"}`}>
          <div className="text-center mb-8">
            <div className="flex justify-left items-center gap-2 mb-4">
              <p className={`mt-3 ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>Ciudad de México a</p>
              <Controller
                name="fecha_autorizaciontx"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <input
                    id="fecha_autorizaciontx"
                    type="date"
                    value={
                      field.value ||
                      (queryFechaTX.data && queryFechaTX.data.length > 0
                        ? queryFechaTX.data[0]?.fecha_autorizaciontx || ""
                        : "")
                    }
                    onChange={(e) => field.onChange(e.target.value)}
                    style={isDarkMode ? {
                      backgroundColor: '#374151',
                      color: '#e5e7eb',
                      borderColor: '#4b5563'
                    } : {}}
                    className={`text-left w-auto border rounded ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : ""}`}
                  />
                )}
              />
            </div>
            <h2 className={`text-xl font-bold mb-4 flex justify-center items-center ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
              AUTORIZACIÓN AL PROCESO DE EVALUACIONES DE PRUEBA TOXICOLÓGICA
            </h2>
          </div>

          <div className="space-y-6">
            <div className="flex items-start">
              <span className={`mr-2 ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>Yo</span>
              <TextInput
                type="text"
                name="name"
                value={`${queryEvaluado.data?.nombre || ""} ${
                  queryEvaluado.data?.apellido_paterno || ""
                } ${queryEvaluado.data?.apellido_materno || ""}`}
                disabled={true}
                onChange={handleInputChange}
                style={isDarkMode ? {
                  backgroundColor: '#374151 !important',
                  color: '#e5e7eb !important',
                  borderColor: '#4b5563 !important'
                } : {}}
                className={`flex-1 mx-2 ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : ""}`}
              />
              <span className={`ml-2 ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                manifiesto haber recibido las indicaciones correspondientes
              </span>
            </div>
            <p className={`text-justify ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
              para el proceso de la presente prueba, asimismo; resolví las dudas
              generadas. Por lo anterior autorizo la realización del análisis
              clínico, para lo cual dono una muestra de orina, verificado
              previamente que el reactivo y el recipiente recolector son nuevos,
              están sellados y su fecha de caducidad es vigente.
            </p>

            <p className={`text-justify ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
              Por consiguiente, otorgo mi consentimiento para enviar esta
              muestra de orina a un laboratorio en caso necesario, y sea
              requerida una prueba confirmatoria.
            </p>

            <p className={`text-justify ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
              Asimismo, autorizo a la empresa SKA TRACKING AND SECURITY S.A. de
              C.V. para que proporcione toda la información y documentación que
              derive de las evaluaciones de pruebas de confianza que me
              realicen.
            </p>

            <p className={`text-justify ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
              En este acto autorizo y conozco el aviso de privacidad el cual se
              encuentra publicado en
              https://skyangel.com.mx/avisodeprivacidad.htlm, por lo cual en
              este acto consiento que SKA TRACKING AND SECURITY S.A. de C.V.
              podrá recabar mis datos personales de conformidad con los términos
              establecidos en dicho aviso.
            </p>

            <p className={`text-justify ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
              Bajo protesta de decir verdad hago constar que los datos
              proporcionados en el proceso de evaluación son verdaderos.
            </p>

            <div className="mt-12 text-center">
              <p className={`mb-8 font-bold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>ATENTAMENTE</p>
              <div className={`w-64 mx-auto border-t pt-2 ${isDarkMode ? "border-gray-400" : "border-black"}`}>
                <p className={`text-sm ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>NOMBRE Y FIRMA</p>
              </div>
            </div>
          </div>
        </div>

        {/* Botones */}
        <div className={`mt-4 mb-4 px-4 ${isDarkMode ? "bg-gray-800" : "bg-white"}`}>
          <div className="flex justify-between">
            <Button
              color="red"
              className={`${isDarkMode ? "bg-red-600 hover:bg-red-700" : ""}`}
              onClick={() => {
                window.scrollTo(0, 0);
                navigate(-1);
              }}
            >
              Regresar
            </Button>
            <button
              type="submit"
              className="bg-green-500 text-white rounded px-4 py-2 z-10"
            >
              {" "}
              Guardar{" "}
            </button>
          </div>
        </div>

        {/* Footer */}
        <div className="bg-customBlue h-12 mt-8 flex items-center justify-center">
          <p className="text-sm text-white px-4">
            <span className="font-bold">DOCUMENTO CONFIDENCIAL</span>, prohibido
            su reproducción, copia o sacar este documento de las Instalaciones
            de Skyangel
          </p>
        </div>
      </form>
    </div>
  </div>
</div>
  );
};
